$(document).ready(function () {

//--- Header mobile menu toggle

$('.header__menu-ico').click(function () {
    $(this).toggleClass('active');
    const headerNav = $('.header__nav');
    if (headerNav.is(':visible')) {
        headerNav.hide();
    } else {
        headerNav.css('display', 'flex');
    }
});

//--- End


//--- Forms

$('.form input:checkbox, .tags input:checkbox').change(function() {
    if (this.checked) {
        $(this).parent().addClass('active');
    } else {
        $(this).parent().removeClass('active');
    }
});

$('.form input:checked, .tags input:checked').parent().addClass('active');

$('.form input:radio').click(function() {
    const thisName = $(this).attr('name');

    $(this).parents().eq(1).find('input[name='+thisName+']').parent().removeClass('active');
    $(this).parent().addClass('active');
});

//--- End


//--- Sort and dropdowns

const hideDrop = function() {
    $('.sort__toggle, .dropdown__toggle').removeClass('active');
    $('.sort__dropdown, .dropdown__content').slideUp(200);
};

$('.sort__toggle, .dropdown__toggle').click(function () {
    $('.sort__dropdown, .dropdown__content').not($(this).next()).slideUp(200);
    $('.sort__toggle').not($(this)).removeClass('active');
    $(this).toggleClass('active').next().slideToggle(250);
});

$('.sort__dropdown li').click(function () {
    const thisText = $(this).text();
    $('.sort__toggle span').text(thisText);
    hideDrop();
});

$(document).click(function(){
    hideDrop();
});

$('.sort, .dropdown').click(function(e){
    e.stopPropagation();
});

//--- End


//--- Accordion

$('.accordion__item__header').click(function () {
    $(this).toggleClass('active').next().slideToggle(250);
});

//--- End


//--- Items inline

const itemsInline = $('.items-inline');

if (itemsInline) {
    const itemsQuantity = $('.items-inline__list .items-inline__item').length;
    if (itemsQuantity > 5) {
        itemsInline.addClass('six');
    }
}

//--- End


//--- Item date

$('.item-date__title.toggle').click(function () {
    $(this).toggleClass('active').next().slideToggle(250);
});

//--- End


//--- Tabs

if ($('.tabs').length > 0) {

    function tabs() {
        const tabLine = $('.tabs__line');
        let tabActive = $('.tabs__list li.active');
        if (!tabActive.length) {
          tabActive = $('.tabs__list li').first();
          tabActive.addClass('active');
        }
        const tabActiveW = $('.tabs__list li.active').width();
        const tabActiveLeft = tabActive.offset().left;
        const tabsLeft = $('.tabs').offset().left;
        tabLine.css({
            'width': tabActiveW,
            'left': tabActiveLeft - tabsLeft
        });
        $('.tabs-content' + '#' + tabActive.attr('data-tab-target')).addClass('active');
    }

    $(document).ready(tabs());

    $(window).resize(function () {
        tabs();
    });

    function selectTab($li) {
        const thisWidth = $li.outerWidth();
        const thisLeft = $li.offset().left;
        $li.parent().find('li.active').removeClass('active');
        $li.addClass('active');
        $('.tabs__line').css({
            'width': thisWidth,
            'left': thisLeft - $('.tabs').offset().left
        });

        const thisTarget = $li.data('tab-target');
        $('.tabs-content').removeClass('active');
        $('.tabs-content' + '#' + thisTarget).addClass('active');

    }
    $('.tabs__list li').click(function () {
        selectTab($(this));
    });

    $('#show-course-tab').click(function () {
        selectTab($('li[data-tab-target="description"]'));
    });
}

//--- End


//--- Notifications

$('.notification__close').click(function () {
    $(this).parent().slideUp(200);
});

setTimeout(function () {
    $('.notification.success').slideUp(200);
}, 5000)

//--- End


//--- Footer links

    if($('.footer__links')) {
        const footerLinksItems = $('.footer__links li').length;

        if (footerLinksItems < 5) {
            $('.footer__links').addClass('one-column');
        } else if (footerLinksItems > 4 && footerLinksItems < 9) {
            $('.footer__links').addClass('two-columns');
        } else if (footerLinksItems > 8) {
            $('.footer__links').addClass('three-columns');
        }

    }

//--- End

//--- Scroll indicator
    $scrollIndicator = $('.full-height__scroll-down');
    $(document).scroll(function () {
        $scrollIndicator.hide();
    });
    $('#why-btn').click(function() {
        $scrollIndicator.hide();

    });


//--- Full-height

if ($('.full-height').length > 0) {
    const wH = $(window).innerHeight();
    const fH =  $('.full-height');

    const fHResponsive = function() {
        const wW = $(window).innerWidth();
        if (wW > 992) {
            fH.css('height', wH - 155);
        } else {
            fH.css('height', wH - 110);
        }
    };

    fHResponsive();

    $(window).resize(function () {
        fHResponsive();
    });

}

//--- End



//--- Tooltips
if ($('.tooltip').length > 0) {

    const responsiveTooltip = function () {
        $('.tooltip').mouseover(function () {

            let tContent = $('.tooltip__content');
            let tContentW = $('.tooltip__content').outerWidth();
            let wWidth = $(window).width();

            let tLeft = $('.tooltip__content').offset().left;
            let tRight = wWidth - (tLeft + tContentW);

            if (tLeft < 0) {
                tContent.addClass('tooltip__content--left').removeClass('tooltip__content--right');
            } else if (tRight < 0) {
                tContent.addClass('tooltip__content--right').removeClass('tooltip__content--left');
            }
        });
    };
    responsiveTooltip();

}

//--- End

//--- Course table links

    $('.course-link').click(function () {
        window.document.location = $(this).data("href");
    });


//--- End


//--- File input
$('input[type="file"]').change(function () {
    $(this).parent().find('input[type="text"]').val($(this).val().replace(/^.*[\\\/]/, ''));
})
$('.form-widget-clearablefileinput button').click(function () {
    $(this).parent().find('input[type="file"]').click();
})
//--- End


//--- Gallery lightbox
if ($('.gallery__item').length) {
    lightbox.option({
        albumLabel: 'Bild %1 av %2',
        fadeDuration: 400,
        resizeDuration: 500,
        positionFromTop: 100
    });
}
//--- End

$('.search-drop__toggle').click(function () {
    const $searchDropContent = $(this).next();
    $searchDropContent.slideToggle(250);
    $('.cart-drop__content').slideUp(200);
    $('#menu-search:visible').focus();
});

$(document).click(function(){
    $('.search-drop__content').slideUp(200);
});

$('.search-drop__content, .search-drop').click(function(e){
    e.stopPropagation();
});

});  // document.ready
